import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import type { CountryEntity } from '@shared/api';
import { CustomDatePicker } from '../CustomDatePicker';
import { Input, ValidateUtils } from '@shared';

interface ISalesOfAssetsProps {
  name: string;
  countries: CountryEntity[];
}

export const SalesOfAssets = (props: ISalesOfAssetsProps) => {
  const { control } = useFormContext();

  return (
    <>
      <Grid item xs={3}>
        <Controller
          name={`${props.name}.asset`}
          control={control}
          rules={{ required: 'Asset is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Asset' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={3}>
        <Controller
          name={`${props.name}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Value' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={3}>
        <Controller
          name={`${props.name}.country`}
          control={control}
          rules={{ required: 'Location is required' }}
          render={({ field, fieldState: { error } }) => (
            <>
              <FormControl margin='normal' fullWidth error={!!error}>
                <InputLabel>Location *</InputLabel>
                <Select {...field} variant='standard' fullWidth>
                  {props.countries.map((country, idx) => (
                    <MenuItem key={idx} value={country.name}>
                      {country.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{error?.message}</FormHelperText>
              </FormControl>
            </>
          )}
        />
      </Grid>
      <Grid item xs={3}>
        <Controller
          name={`${props.name}.date`}
          control={control}
          rules={{ required: 'Date is required', validate: { isValidDate: ValidateUtils.isValidDate } }}
          render={({ field, fieldState: { error } }) => (
            <CustomDatePicker {...field} label='Date' margin='normal' fullWidth required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
    </>
  );
};
